import theme from 'src/theme';

export const timeSeriesSx = {
    root: {
        bgcolor: theme.palette.common.white,
        borderRadius: '14px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
        overflow: 'hidden',
    },
    tabsBar: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 2,
        px: 3,
        pt: 1.5,
        borderBottom: `1px solid ${theme.palette.neutral[100]}`,
        flexWrap: 'wrap',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            px: '14px',
        },
    },
    tabs: {
        display: 'flex',
        gap: 0.5,
        flexWrap: 'wrap',
    },
    tab: {
        px: 2,
        py: 1.25,
        borderRadius: '8px 8px 0 0',
        fontSize: '0.82rem',
        fontWeight: 500,
        color: theme.palette.neutral[600],
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'all 0.15s ease',
        borderBottom: '2px solid transparent',
        '&:hover': {
            color: theme.palette.neutral[800],
            bgcolor: theme.palette.neutral[50],
        },
    },
    tabActive: {
        px: 2,
        py: 1.25,
        borderRadius: '8px 8px 0 0',
        fontSize: '0.82rem',
        fontWeight: 600,
        color: theme.palette.primary.main,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    content: {
        p: 3,
        // The kit's card padding. 24px of it on a 390px screen is a sixth of the width.
        [theme.breakpoints.down('md')]: {
            p: '14px',
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        mb: 2,
        gap: 2,
        flexWrap: 'wrap',
    },
    title: {
        fontSize: '1rem',
        fontWeight: 600,
        color: theme.palette.neutral[800],
        letterSpacing: '-0.01em',
    },
    segmentedRoot: {
        display: 'inline-flex',
        p: '3px',
        bgcolor: theme.palette.neutral[50],
        borderRadius: '10px',
        border: `1px solid ${theme.palette.neutral[100]}`,
    },
    segmentButton: {
        px: 1.75,
        py: 0.5,
        borderRadius: '7px',
        fontSize: '0.78rem',
        fontWeight: 500,
        textTransform: 'none',
        color: theme.palette.neutral[600],
        minWidth: 'auto',
        transition: 'all 0.15s ease',
        '&:hover': {bgcolor: 'transparent', color: theme.palette.neutral[800]},
    },
    segmentButtonActive: {
        px: 1.75,
        py: 0.5,
        borderRadius: '7px',
        fontSize: '0.78rem',
        fontWeight: 600,
        textTransform: 'none',
        bgcolor: theme.palette.common.white,
        color: theme.palette.primary.main,
        minWidth: 'auto',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        '&:hover': {bgcolor: theme.palette.common.white},
    },
    chartContainer: {
        width: '100%',
        height: 300,
        // The columns as drawn: about 150px of bar plus its labels, not a third of the screen.
        [theme.breakpoints.down('md')]: {
            height: 220,
        },
    },
    empty: {
        height: 300,
        [theme.breakpoints.down('md')]: {
            height: 220,
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.neutral[500],
        fontSize: '0.875rem',
    },
};
